<template>
    <div class="layout-right">
            <div class="layout-right-top">
                <right-top bread="连锁管理-员工管理"></right-top>
            </div>
            <div class="layout-right-body">
                <div class="item-box search-box">
                    <el-input v-model="searchData.keyword" placeholder="姓名/联系手机" style="width: 300px" />&nbsp;
                    <el-select v-model="searchData.store_id" placeholder="请选择门店" clearable class="select">
                        <el-option label="所有门店" value=""></el-option>
                        <el-option
                                v-for="store in chainStoreArr"
                                :key="store.id"
                                :label="store.store_name"
                                :value="store.id">
                        </el-option>
                    </el-select>&nbsp;
                    <el-button type="primary" icon="el-icon-search" @click="searchEvent">搜索</el-button>
                </div>

                <div class="item-content" ref="itemContent">
                    <div class="table-box staff-list">
                        <el-table :data="tableData" size="medium" ref="tableData" cell-class-name="table-ceil" header-cell-class-name="table-ceil">
                            <el-table-column prop="username" label="用户名"></el-table-column>
                            <el-table-column prop="mobile" label="联系电话"></el-table-column>
                            <el-table-column prop="name" label="姓名">
                                <template slot-scope="data">
                                    {{data.row.name}}&nbsp;<el-tag v-if="data.row.job_name" type="warning">{{data.row.job_name}}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="role_name" label="分类"></el-table-column>
                            <el-table-column prop="work_id" label="工号" width="100"></el-table-column>
                            <el-table-column prop="store_name" label="所属门店" align="center" width="200"></el-table-column>
                        </el-table>
                    </div>
                    <div class="page-box">
                        <el-pagination
                                @size-change="pageSizeChange"
                                @current-change="pageCurrentChange"
                                :current-page="page.nowPage"
                                :page-sizes="page.pageSizes"
                                :page-size="page.pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="page.count">
                        </el-pagination>
                    </div>
                </div>
            </div>
            <div class="layout-right-bottom">
                <!--右下-->

            </div>
        </div>
</template>

<script>
    import obj from "@/js/obj";
    import Menu from "@/model/Menu";
    import SearchBox from "@/model/SearchBox";
    import PopForm from "@/model/PopForm";
    import RightTop from "@/model/RightTop";
    export default {
        name: "StoreStaffList",
        components: {RightTop, PopForm, SearchBox, Menu},
        data: () => ({
            tableData: [],
            page: {
                nowPage: 1,
                pageSize: 50,
                pageSizes: [50, 100, 200, 400],
                count: 0,
            },
            searchData: {
                keyword: "",
                store_id: ""
            },
            chainStoreArr: [],      //门店列表
        }),
        mounted: function(){
            this.$store.commit("setMenuId", "14-5");
            this.loadChainStore();
            this.loadListData();

        },
        methods: {
            //每页显示数量变化
            pageSizeChange: function (val) {
                this.page.pageSize = val;
                this.loadListData();
            }

            //当前页码变化
            ,pageCurrentChange: function (val) {
                this.page.nowPage = val;
                this.loadListData();
            }

            //加载所有门店
            ,loadChainStore: function () {
                this.$root.postData("chain/get_child_store_list_short", {}, res => {
                    if(res.errcode === 0){
                        this.chainStoreArr = res.data;
                    }else{
                        this.$root.error(res.errdesc);
                    }
                });
            }

            //加载列表数据
            ,loadListData: function () {
                let postData = {
                    offset: (this.page.nowPage - 1) * this.page.pageSize,
                    limit: this.page.pageSize,
                    keyword: this.searchData.keyword ? this.searchData.keyword : "",
                    search_store_id: this.searchData.store_id ? this.searchData.store_id : ""
                };
                obj.postData("chain/get_store_staff_list", postData, function (res) {
                    if(res.errcode === 0){
                        this.tableData = res.data.listData;
                        this.page.count = res.data.count;
                    }else{
                        this.tableData = [];
                    }
                }.bind(this));
            }

            //搜索
            ,searchEvent: function () {
                this.loadListData();
            }
        }
    }
</script>

<style scoped>
    .layout-right-body>.search-box{
        padding: 16px;
    }
</style>
